import React from 'react';
import { Form } from 'react-bootstrap';
import { Check2Square, Square } from 'react-bootstrap-icons';
import './SectionSelector.scss';

// ============================================
// Section Configuration
// ============================================

export interface ReportSection {
  id: string;
  label: string;
  description: string;
  icon?: React.ReactNode;
  required?: boolean;
}

export interface SectionSelectorProps {
  sections: ReportSection[];
  selectedSections: Set<string>;
  onToggleSection: (sectionId: string) => void;
  onToggleAll: () => void;
}

// ============================================
// Main Component
// ============================================

const SectionSelector: React.FC<SectionSelectorProps> = ({
  sections,
  selectedSections,
  onToggleSection,
  onToggleAll
}) => {
  const allSelected = sections.every(section => 
    section.required || selectedSections.has(section.id)
  );
  
  const selectableCount = sections.filter(s => !s.required).length;
  const selectedCount = sections.filter(s => 
    !s.required && selectedSections.has(s.id)
  ).length;

  return (
    <div className="section-selector">
      <div className="section-selector__header">
        <div className="section-selector__title-group">
          <h4 className="section-selector__title">Contenido del Reporte</h4>
          <span className="section-selector__subtitle">
            Selecciona las secciones a incluir en el PDF
          </span>
        </div>
        <div className="section-selector__actions">
          <button
            type="button"
            className="section-selector__toggle-all"
            onClick={onToggleAll}
          >
            {allSelected ? (
              <>
                <Check2Square size={16} />
                Deseleccionar todo
              </>
            ) : (
              <>
                <Square size={16} />
                Seleccionar todo
              </>
            )}
          </button>
          <span className="section-selector__counter">
            {selectedCount} de {selectableCount}
          </span>
        </div>
      </div>

      <div className="section-selector__grid">
        {sections.map((section) => {
          const isSelected = selectedSections.has(section.id);
          const isDisabled = section.required;

          return (
            <div
              key={section.id}
              className={`section-card ${isSelected ? 'section-card--selected' : ''} ${
                isDisabled ? 'section-card--disabled' : ''
              }`}
              onClick={() => !isDisabled && onToggleSection(section.id)}
            >
              <div className="section-card__checkbox">
                <Form.Check
                  type="checkbox"
                  checked={isSelected}
                  disabled={isDisabled}
                  onChange={() => !isDisabled && onToggleSection(section.id)}
                  onClick={(e) => e.stopPropagation()}
                  className="custom-checkbox"
                />
              </div>
              
              <div className="section-card__content">
                <div className="section-card__header">
                  <span className="section-card__label">{section.label}</span>
                  {isDisabled && (
                    <span className="section-card__badge">Requerido</span>
                  )}
                </div>
                <p className="section-card__description">{section.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SectionSelector;
